import { render } from "./JFstatistics.vue?vue&type=template&id=6208e75c&scoped=true"
import script from "./JFstatistics.vue?vue&type=script&lang=js"
export * from "./JFstatistics.vue?vue&type=script&lang=js"

import "./JFstatistics.vue?vue&type=style&index=0&id=6208e75c&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6208e75c"]])

export default __exports__